import React from "react";
import { Modal, Form, Input, Select, Space } from "antd";

export const CarFilter = ({
  form,
  isModalOpen,
  handleCancel,
  setFilterForm,
  filterForm,
  handleFilter,
  vendorList,
}) => {
  return (
    <Modal
      title="Filters"
      open={isModalOpen}
      onOk={handleFilter}
      okText="Filter Data"
      onCancel={handleCancel}
    >
      <Form form={form} layout="vertical">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <Form.Item name="ownerId" className="subscription-plan">
            <Select
              value={filterForm?.ownerId}
              onChange={(value) =>
                setFilterForm({ ...filterForm, ownerId: value })
              }
              placeholder="Filter by Vendor"
              style={{ width: "100%" }}
            >
              {vendorList?.length > 0 ? (
                vendorList.map((vendor) => (
                  <Select.Option key={vendor.id} value={vendor.id}>
                    {vendor.fullName}
                  </Select.Option>
                ))
              ) : (
                <Select.Option value="default">Loading...</Select.Option>
              )}
            </Select>
          </Form.Item>
        </div>
      </Form>
    </Modal>
  );
};
